module.exports = __webpack_public_path__ + "static/img/icon2.fa924b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/icon2.png
// module id = H930
// module chunks = 21